<script>
export default
{
    name: 'mv-modal',

    methods:
    {
        open()
        {
            $(this.$refs.modal).modal('show')
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$gmapDefaultResizeBus.$emit('resize')
                }, 500)
            })
        },

        close()
        {
            $(this.$refs.modal).modal('hide')
        },
    }
}
</script>
<template>
<div class="modal fade" role="dialog" tabindex="-1" aria-hidden="true" ref="modal">
    <div class="modal-content">
        <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">&times;</button>
            <h4 class="modal-title">
                <slot name="header"></slot>
            </h4>
        </div>

        <div class="modal-body">
            <slot></slot>
        </div>

        <div class="modal-footer">
            <slot name="footer"></slot>
        </div>
    </div>
</div>
</template>


// WEBPACK FOOTER //
// src/components/Modal.vue